export default import.meta.ROLLUP_FILE_URL_rUPbsx1MHUotsWMDld2q1w